export default __webpack_public_path__ + "static/media/2.223be346.png";